import {
  applyMiddleware,
  configureStore
} from "@reduxjs/toolkit";
import authReducer from "../redux/auth/slice";
import { thunk } from "redux-thunk";

const store = configureStore(
  {
    reducer: {
      auth: authReducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }),
  },
  applyMiddleware(thunk)
);

export default store;